import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import { pushRelateds } from './related';
import { pushItem, pushItems } from '../../reducers/entities';
import * as norm from '@rexlabs/entity-normalizer';
import invariant from 'invariant';
import _ from 'lodash';
export var ACTION_DELETE_ENTITY = 'entities/DELETE_ENTITY';
/**
 * Returns action creators for local entity manipulations
 * @param  {string} type
 * @param  {Object} config
 * @return {Object}
 */

export function getLocalActionCreators(type, config) {
  return {
    // Pushes an item into the redux store
    // Needs to be an async action, as we potentially want to trigger actions
    //  on other entities from here to push related information!
    pushItem: {
      request: function request(payload, model, dispatch) {
        invariant(payload.data, 'You need to define the item data you want to push => \'pushItem({data: {...}})\'');
        return new _Promise(function (resolve) {
          var _context;

          var _norm$processEntityIt = norm.processEntityItem({
            data: payload.data
          }, config.related),
              item = _norm$processEntityIt.item,
              related = _norm$processEntityIt.related,
              relatedData = _norm$processEntityIt.relatedData;

          _forEachInstanceProperty(_context = _Object$keys(related)).call(_context, function (key) {
            delete item[key];
          });

          pushRelateds(dispatch, config.related, relatedData, payload.uuid);
          resolve({
            data: item,
            related: related
          });
        });
      },
      reduce: {
        initial: _.identity,
        success: pushItem
      }
    },
    // Same as bulk action
    pushItems: {
      request: function request(payload, model, dispatch) {
        invariant(_.isArray(payload.items), 'You need to define the items you want to push => \'pushItems({items: [{...}]})\'');
        return new _Promise(function (resolve) {
          var _context2;

          payload.related = {};

          _forEachInstanceProperty(_context2 = payload.items).call(_context2, function (data, i) {
            var _context3;

            var _norm$processEntityIt2 = norm.processEntityItem({
              data: data
            }, config.related),
                related = _norm$processEntityIt2.related,
                relatedData = _norm$processEntityIt2.relatedData; // NOTE: this is a hack to quick fix store duplication issues!


            _forEachInstanceProperty(_context3 = _Object$keys(related)).call(_context3, function (key) {
              delete payload.items[i][key];
            });

            pushRelateds(dispatch, config.related, relatedData, payload.uuid);
            payload.related[data.id] = related;
          }); // TODO: check if that is correct that we pass down the whole payload..


          resolve(payload);
        });
      },
      reduce: {
        initial: _.identity,
        success: pushItems
      }
    },
    removeItem: {
      actionName: ACTION_DELETE_ENTITY,
      reduce: function reduce(state, action) {
        var _action$payload = action.payload,
            type = _action$payload.type,
            id = _action$payload.id;
        invariant(id, 'You have to define the id of the item you want to remove => \'removeItem({id: ..., type: ...})\'');
        invariant(type, 'You have to define the type of the entity you want to remove => \'removeItem({id: ..., type: ...})\'');
        return norm.removeRelatedItem(state, type, id);
      }
    },
    // List item meta data handling
    pushListItemMeta: {
      reduce: function reduce(state, action) {
        var _action$payload2 = action.payload,
            listId = _action$payload2.listId,
            itemId = _action$payload2.itemId,
            meta = _action$payload2.meta;
        invariant(listId, 'You need to pass in the ID of the list you want to store meta data on => \'pushListItemMeta({listId: ..., itemId: ..., meta: {...}})\'');
        invariant(itemId, 'You need to define the ID of the list item for the meta data => \'pushListItemMeta({listId: ..., itemId: ..., meta: {...}})\'');
        invariant(meta && _.isObject(meta), 'You need to pass in the meta data as an object => \'pushListItemMeta({listId: ..., itemId: ..., meta: {...}})\'');
        return norm.setListItemMeta(state, listId, itemId, meta);
      }
    },
    removeListItemMeta: {
      reduce: function reduce(state, action) {
        var _action$payload3 = action.payload,
            listId = _action$payload3.listId,
            itemId = _action$payload3.itemId,
            meta = _action$payload3.meta,
            metaKey = _action$payload3.metaKey;
        invariant(listId, 'You need to pass in the ID of the list you want to remove meta data from => \'removeListItemMeta({listId: ..., itemId: ..., metaKey: ...})\'');
        invariant(itemId, 'You need to define the ID of the list item to remove the meta data from => \'removeListItemMeta({listId: ..., itemId: ..., metaKey: ...})\'');
        invariant(meta && _.isObject(meta), 'You need to pass in the meta key you want to remove => \'removeListItemMeta({listId: ..., itemId: ..., metaKey: ...})\'');
        return norm.removeListItemMeta(state, listId, itemId, metaKey);
      }
    }
  };
}
/**
 * Generic `removeItem` action
 * @param  {string} type
 * @param  {string} id
 * @return {Object} Redux action
 */

export function removeItem(type, id) {
  return {
    type: ACTION_DELETE_ENTITY,
    payload: {
      type: type,
      id: id
    }
  };
}